"use strict";

const OverflowTooltip = function () {
  const GENERATED_TITLE_ATTRIBUTE = "data-overflow-tooltip";
  const FORM_CONTROL_SELECTOR = "input, select, textarea";

  var init = function () {
    $(document).off("mouseover.overflowTooltip").on("mouseover.overflowTooltip", updateTooltip);
  };

  var updateTooltip = function (e) {
    const ellipsisElement = findEllipsisElement(e.target);
    if (!ellipsisElement || hasTemplateTitle(e.target, ellipsisElement)) {
      return;
    }

    if (isOverflowing(ellipsisElement)) {
      ellipsisElement.setAttribute("title", ellipsisElement.textContent.trim());
      ellipsisElement.setAttribute(GENERATED_TITLE_ATTRIBUTE, "");
    } else if (ellipsisElement.hasAttribute(GENERATED_TITLE_ATTRIBUTE)) {
      ellipsisElement.removeAttribute("title");
      ellipsisElement.removeAttribute(GENERATED_TITLE_ATTRIBUTE);
    }
  };

  var findEllipsisElement = function (target) {
    for (
      let element = target;
      element && element !== document.body;
      element = element.parentElement
    ) {
      if (element.matches(FORM_CONTROL_SELECTOR)) {
        return null;
      }
      if (getComputedStyle(element).textOverflow === "ellipsis") {
        return element;
      }
    }
    return null;
  };

  // A title written by a template (e.g. the full value of `truncatedText`) is more accurate than
  // the rendered text, which may already be shortened, so it takes precedence.
  var hasTemplateTitle = function (target, ellipsisElement) {
    for (
      let element = target;
      element !== ellipsisElement.parentElement;
      element = element.parentElement
    ) {
      if (element.getAttribute("title") && !element.hasAttribute(GENERATED_TITLE_ATTRIBUTE)) {
        return true;
      }
    }
    return false;
  };

  var isOverflowing = function (element) {
    return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
  };

  return {
    init,
  };
};

module.exports = OverflowTooltip();
